import { Period } from '../../../enums/reports';
import { useGetOccupancyQuery } from '../../../../app/Slices/SevenDayApiSlice';
import { Card, CardContent, Typography, useTheme } from '@mui/material';
import React from 'react';
import {
    Bar,
    BarChart,
    CartesianGrid,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis,
} from 'recharts';
import { useNavigate } from 'react-router';

interface ExperienceChartProps {
    period: Period;
}

const ExperienceChart = ({ period }: ExperienceChartProps) => {
    const navigate = useNavigate();
    const { data } = useGetOccupancyQuery({
        period,
    });

    const theme = useTheme();

    if (!data) return <></>;

    return (
        <Card sx={{ height: '100%' }}>
            <CardContent>
                <Typography variant='subHeading'>All Experiences</Typography>
                <Typography variant='subtitle2' gutterBottom>
                    Occupancy
                </Typography>
                <ResponsiveContainer width='100%' height={350}>
                    <BarChart
                        data={data}
                        onClick={(e) => {
                            if (!e.activePayload?.[0]?.payload?.id) return;
                            navigate(`${e.activePayload?.[0]?.payload.id}`);
                        }}
                    >
                        <CartesianGrid strokeDasharray='3 3' />
                        <XAxis
                            dataKey='name'
                            angle={45}
                            textAnchor='start'
                            height={100}
                            interval={0}
                            tickFormatter={(value) =>
                                `${
                                    value.length > 10
                                        ? `${value.slice(0, 10)}...`
                                        : value
                                }`
                            }
                        />
                        <YAxis domain={[0, 100]} unit='%' />
                        <Tooltip
                            labelFormatter={(label, payload) => {
                                return (
                                    <>
                                        <span>{label}</span>
                                        <br />
                                        <span>
                                            Available Nights:{' '}
                                            {
                                                payload[0]?.payload
                                                    ?.availableNights
                                            }
                                        </span>
                                        <br />
                                        <span>
                                            Occupied Nights:{' '}
                                            {
                                                payload[0]?.payload
                                                    ?.availableOccupiedNights
                                            }
                                        </span>
                                    </>
                                );
                            }}
                            formatter={(value: number) =>
                                `${value.toFixed(1)}%`
                            }
                        />
                        <Bar
                            dataKey='availableNightsOccupancy'
                            name='Occupancy'
                            fill={theme.palette.textAccent.main}
                        />
                    </BarChart>
                </ResponsiveContainer>
                <Typography variant='caption'>
                    **Occupancy calculated as the number of reserved nights,
                    divided by the number of available nights. Day reservations
                    and reservations that fall outside of current availability
                    are excluded from this number
                </Typography>
            </CardContent>
        </Card>
    );
};

export default ExperienceChart;
